module.exports = __webpack_public_path__ + "img/db11628.jpg";